import {Component, inject} from '@angular/core';
import {TenantAccount} from "../../../../../services/model/account.model";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {Subscription, tap} from "rxjs";
import {CurrentTenantService} from "../../../../../services/front/current-tenant.service";
import {AccountService, UpdateAccountForm} from "../../../../../services/account.service";
import {DesignSystemModule} from "../../../../design-system/design-system.module";
import {TranslateModule} from "@ngx-translate/core";
import {MatDialogRef} from "@angular/material/dialog";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-edit-account-dialog',
	imports: [
		DesignSystemModule,
		TranslateModule,
		ReactiveFormsModule,
		NgIf
	],
  templateUrl: './edit-account-dialog.component.html',
  styleUrl: './edit-account-dialog.component.scss'
})
export class EditAccountDialogComponent {
	formGroup: FormGroup = new FormGroup({
		lastName: new FormControl<string | null>(null, [Validators.required]),
		firstName: new FormControl<string | null>(null, [Validators.required]),
	})

	subscription: Subscription = new Subscription();

	initialized: boolean = false;

	_saving: boolean = false;

	currentTenantService = inject(CurrentTenantService);
	accountService = inject(AccountService);

	dialogRef: MatDialogRef<EditAccountDialogComponent> = inject(MatDialogRef<EditAccountDialogComponent>);

	ngOnInit(): void {
		this.subscription.add(this.currentTenantService.getTenantAccountChanges()
			.pipe(tap((account) => this.setDefaultData(account)))
			.subscribe(() => this.initialized = true));

		this.subscription.add(this.formGroup.get('lastName')?.valueChanges
			.subscribe((value) => {
				if (value?.trim() === '') {
					this.formGroup.get('lastName')!.setErrors({required: true});
				} else {
					this.formGroup.get('lastName')!.setErrors(null);
				}
			}));

		this.subscription.add(this.formGroup.get('firstName')?.valueChanges
			.subscribe((value) => {
				if (value?.trim() === '') {
					this.formGroup.get('firstName')!.setErrors({required: true});
				} else {
					this.formGroup.get('firstName')!.setErrors(null);
				}
			}));
	}

	private setDefaultData(account: TenantAccount): void {
		this.formGroup.patchValue({
			lastName: account.account.lastName,
			firstName: account.account.firstName
		});
	}

	submit(): void {
		if (this.formGroup.invalid) {
			return;
		}

		const trimmedLastName = this.formGroup.get('lastName')!.value?.trim();
		const trimmedFirstName = this.formGroup.get('firstName')!.value?.trim();

		const form: UpdateAccountForm = {
			lastName: trimmedLastName,
			firstName: trimmedFirstName
		}

		this._saving = true;

		this.accountService.updateAccount(form)
			.subscribe({
				next: (result) => {
					this.closeDialog(result);
				},
				error: () => {
					this.closeDialog(false);
				}
			});
	}

	closeDialog(result: boolean) {
		this.dialogRef.close(result);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
